// extracted by mini-css-extract-plugin
module.exports = {"container":"_5cm94","content":"_12WLx","section":"_1x2a3","sectionTitle":"nXQ4x","sectionDescription":"_11IHP","separator":"R3mk9"};